import { deepObjectCopy } from 'src/utils'
import type { SearchSort } from '@faststore/sdk/dist/types'

import type {
  ApplyFiltersProps,
  ApplyFiltersPriceType,
} from '../types/applyFilterProps'

function conditionOrDefaultValue(condition: boolean, value: string) {
  return condition ? value : ''
}

function handlePriceFilter(price: ApplyFiltersPriceType) {
  return price.minPriceSelected === undefined &&
    price.maxPriceSelected === undefined
    ? null
    : {
        key: 'price',
        value: `${price.minPriceSelected ?? price.minAbsolutePrice}-to-${
          price.maxPriceSelected ?? price.maxAbsolutePrice
        }`,
      }
}

function newUrlFilter(
  queryStringFacets: string,
  queryStringFilter: string,
  price: ApplyFiltersPriceType,
  sort?: SearchSort
) {
  const pathname = `${window?.location?.pathname}?`
  const termText = price.term && `q=${price?.term}&`
  const StringFilterText = `${queryStringFilter}facets=`
  const StringFacetsText = `${queryStringFacets}sort=${
    sort ?? 'score_desc'
  }&page=0`

  const priceFilter =
    price?.minPriceSelected !== undefined ||
    price?.maxPriceSelected !== undefined

  const priceFilterText01 = conditionOrDefaultValue(
    priceFilter,
    `price=${price?.minPriceSelected ?? price?.minAbsolutePrice}-to-${
      price?.maxPriceSelected ?? price?.maxAbsolutePrice
    }&`
  )

  const priceFilterText02 = conditionOrDefaultValue(
    priceFilter && !queryStringFacets?.includes('price'),
    `price${queryStringFacets === '' ? '&' : '%2C'}`
  )

  return (
    pathname +
    termText +
    priceFilterText01 +
    StringFilterText +
    priceFilterText02 +
    StringFacetsText
  )
}

export const applyFilters: ApplyFiltersProps = (
  { minAbsolutePrice, maxAbsolutePrice, minPriceSelected, maxPriceSelected },
  selectedFacetsFilter,
  setSelectedFacets,
  sort
) => {
  let queryStringFilter = ''
  let queryStringFacets = ''
  const selectedFacets = deepObjectCopy(selectedFacetsFilter)
  const term = conditionOrDefaultValue(
    window?.location?.search?.indexOf('?q=') !== -1,
    window?.location?.search?.split('q=')[1]?.split('&')[0]
  )

  const keyFacets: string[] = []

  if (
    selectedFacets?.length === 0 &&
    minPriceSelected === undefined &&
    maxPriceSelected === undefined
  ) {
    const newSort = sort ?? 'score_desc'
    const newUrlSearch = term
      ? `${window?.location?.pathname}?q=${term}&sort=${newSort}&page=0`
      : window?.location?.pathname

    window.history.replaceState({}, '', newUrlSearch)
    setSelectedFacets?.(selectedFacetsFilter)

    return
  }

  for (const facet of selectedFacets) {
    keyFacets.push(facet.key)
  }

  const keyFacetsFiltered: string[] = []

  keyFacets?.forEach((facet) => {
    !keyFacetsFiltered?.includes(facet) && keyFacetsFiltered.push(facet)
  })

  for (const facet of selectedFacets) {
    queryStringFilter += `${facet.key}=${facet.value}&`
  }

  keyFacetsFiltered?.forEach((keyFacet, i) => {
    queryStringFacets += `${keyFacet}${
      i === keyFacetsFiltered.length - 1 ? '&' : '%2C'
    }`
  })

  const price = {
    minAbsolutePrice,
    maxAbsolutePrice,
    minPriceSelected,
    maxPriceSelected,
    term,
  }

  const priceFilter = handlePriceFilter(price)

  const newFacets = !priceFilter
    ? selectedFacets
    : [...selectedFacets, priceFilter]

  const newUrl = newUrlFilter(queryStringFacets, queryStringFilter, price, sort)

  setSelectedFacets?.(newFacets)

  if (
    `${window?.location?.origin}${newUrl}&filtered` !==
    decodeURIComponent(window?.location?.href)?.replaceAll(',', '%2C')
  ) {
    window.history.pushState({}, '', `${newUrl}&filtered`)
  }
}
